import React, { useState } from 'react'
import { TextField, Button, InputAdornment } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import whatsappService from '../services/whatsappService'
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { loginSuccessAction } from '../redux/actions/authActions';

export const WhatsappLogin = () => {
    const [phone, setPhone] = useState('7772001991');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        console.log(`Login via whatsapp: `, phone);
        e.preventDefault();
        try {
            if (!phone || phone.length < 10) {
                toast.error('Номер телефона не может быть пустым', {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
                return;
            }
            const phonePrefix = '7';
            const phoneNumber = phonePrefix + phone;
            const { data } = await whatsappService.signin(phoneNumber);
            console.log(data);            

            toast.success(data.message, {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });

            setTimeout(() => {
                navigate(`/login/whatsapp/verify?phone=${phoneNumber}`);
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full max-w-md mx-auto mt-10 p-4 border rounded-md h-[500px]">
            <TextField
                label="Номер телефона WhatsApp"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <span>+7</span>
                        </InputAdornment>
                    ),
                }}
            />
            <Button type='submit' variant="contained" color="primary">Отправить код</Button>
            <ToastContainer />
        </form>
    )
}
